export default {
	setLotsList(state, data) {
		state.lotsList = data;
	},
	setTypes(state, data) {
		state.typesArr = data;
	},
	setVehicleTypes(state, data) {
		state.vehicleTypes = data;
	},
	setProviders(state, data) {
		state.providersArr = data;
	},
	setBrokers(state, data) {
		state.brokersArr = data;
	},
	setWarehousesArr(state, data) {
		state.warehousesArr = data;
	},
	setCrossings(state, data) {
		state.crossings = data;
	},
	setClearances(state, data) {
		state.clearances = data;
	},
	setCargoTypes(state, data) {
		state.cargoTypes = data;
	},
	setCurrencies(state, data) {
		state.currencies = data;
	}

};
